import { Observable } from 'rxjs'

import { AccessManagementUser } from '@flowx/designer/modules/workspaces/shared/workspace.utils'
import { AccessManagementUsersApiService } from '@flowx/designer/shared/api/access-management-users.api'
import { PaginationQueryParams } from '@flowx/designer/shared/api/api-http.service'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PaginatedEndpoint,
  PaginatedResponse,
  Sort,
} from '@flowx/designer/shared/services/paginated-datasource'

const SORT_FIELD = 'username'

/**
 * Users grid state for the access-management store. Dependencies arrive via the
 * constructor (not `inject`) so instances can be re-created when the user type
 * changes; construction still requires an injection context for the base class.
 */
export class UsersGridSearch extends GridSearchService<AccessManagementUser> {
  #usersApi: AccessManagementUsersApiService
  #initialSearchQuery?: string

  constructor(usersApi: AccessManagementUsersApiService, initialSearchQuery?: string) {
    super()
    this.#usersApi = usersApi
    this.#initialSearchQuery = initialSearchQuery
  }

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<any, AccessManagementUser>
    sort: Sort
    query: Partial<any>
  } {
    return {
      endpoint: this.#getUsers.bind(this),
      sort: {
        property: SORT_FIELD,
        direction: 'asc',
      },
      query: { filterKey: this.#initialSearchQuery },
    }
  }

  #getUsers(
    paginationParams: PaginationQueryParams,
    query: Partial<any>
  ): Observable<PaginatedResponse<AccessManagementUser[]>> {
    return this.#usersApi.getUsers({ ...paginationParams, ...query })
  }
}
